import React from 'react';
import { TransferPersonalDataTable } from './TransferPersonalDataTable';
import { TextSmall } from '@/components/Texts';

const transferList = [
  '-The data is transferred to a third party service provider for the operation of our website and the processing of data stored or transmitted by the systems (e.g. for data center services, payment processing, IT security). The legal basis for the transfer is then Art. 6 para. 1 p. 1 lit. b or lit. f GDPR, insofar as it does not involve order processors;',
  '-State agencies/authorities/Law Enforcement Requests, insofar as this is necessary for the fulfillment of a legal obligation. The legal basis for the disclosure is then Art. 6 para. 1 p. 1 lit. c GDPR. Occasionally, Diment receives information requests from law enforcement agencies worldwide. In such instances, Diment may be compelled to disclose and/or voluntarily provide your Personal Information to law enforcement agencies and/or a government, if it is deemed reasonable and necessary. By agreeing to the Terms of Service, you consent to the sharing of your Personal Information as elaborated;',
  '-Persons appointed to carry out our business operations (e.g. auditors, banks, insurance companies, legal advisors, supervisory authorities, parties involved in company acquisitions or the establishment of joint ventures). The legal basis for the disclosure is then Art. 6 para. 1 p. 1 lit. b or lit. f GDPR.',
];

const TransferPersonalDataBasisJustification = () => {
  return (
    <>
      <TextSmall fontWeight={700}>
        (4) Transfer of personal data to third parties; basis for justification
      </TextSmall>
      <TextSmall>
        The following categories of recipients, which are usually processors
        (see A.(7)), may receive access to your personal data:
      </TextSmall>
      {transferList.map((data, index) => (
        <TextSmall key={index + 'transferlist'} pl={4}>
          {data}
        </TextSmall>
      ))}
      <TextSmall fontWeight={700}>
        List of Third-Party Service Providers with whom Personal Information may
        be shared:
      </TextSmall>
      <TransferPersonalDataTable />
      <TextSmall pl={4}>
        - Any member of our group, which means our direct or indirect
        subsidiaries, our ultimate{' '}
        <TextSmall as={'span'} fontWeight={700}>
          {' '}
          holding company
        </TextSmall>{' '}
        and any other subsidiary of that{' '}
        <TextSmall as={'span'} fontWeight={700}>
          {' '}
          holding company
        </TextSmall>
        , including their respective shareholders, directors, officers,
        affiliates, employees, contractors, agents, partners, insurers, and
        attorneys or representatives;
      </TextSmall>
      <TextSmall>
        For the guarantees of an adequate level of data protection in the event
        of a transfer of the data to third countries, see A.(8).
      </TextSmall>
      <TextSmall>
        In addition, we will only disclose your personal data to third parties
        if you have given your express consent to do so in accordance with Art.
        6 (1) p. 1 lit. a GDPR.
      </TextSmall>
    </>
  );
};

export default TransferPersonalDataBasisJustification;
